import { FC } from 'react';
import { IconType } from 'react-icons/lib';
import { merge } from '../../utils/utility';

export enum FramedIconSize {
  SMALL,
  LARGE
}

interface Props {
  Icon: IconType;
  className?: string;
  secondary?: boolean;
  size?: FramedIconSize;
}

export const FramedIcon: FC<Props> = ({ Icon, className, secondary, size = FramedIconSize.SMALL }) => {
  let classToUse = merge(className, "flex items-center justify-center text-white");

  switch (size) {
    case FramedIconSize.SMALL:
      classToUse = merge(classToUse, 'w-12 h-12');
      break;
    case FramedIconSize.LARGE:
      classToUse = merge(classToUse, 'w-16 h-16');
      break;
  }

  classToUse = merge(classToUse, secondary ? 'bg-secondary-800' : 'bg-primary-800');
  return (
    <div className={classToUse}>
      <Icon className="h-1/2 w-1/2" />
    </div>
  );
};
